/**
 *TriggerEvents
 */
window.__GP_EVENTS__ = window.__GP_EVENTS__ || {};
/**
 * Events
 */
class Events {
  /**
   * on: watch events
   * @param key key
   * @param func func
   * @returns function unsubscribe
   */
  on(key: string, func: any): () => any {
    Object(window.__GP_EVENTS__)[key] = Object(window.__GP_EVENTS__)[key] || {
      func: [],
    };
    Object(window.__GP_EVENTS__)[key].func.push(func);
    return this.off(key, func);
  }

  /**
   * trigger events
   * @param key string
   * @param value any
   */
  trigger(key: string, value?: any) {
    Object(window.__GP_EVENTS__)[key] = Object(window.__GP_EVENTS__)[key] || {
      func: [],
    };
    const dataFunc = Object(window.__GP_EVENTS__)[key].func;
    for (let i = 0; i < dataFunc.length; i++) {
      const func = dataFunc[i];
      func(value);
    }
  }

  /**
   * delete
   * @param key string
   * @param _func func
   * @returns function unsubscribe
   */
  off(key: string, _func: any) {
    return () => {
      delete Object(window.__GP_EVENTS__)[key];
    };
  }

  /**
   * clear store of this key
   * @param key string
   * @returns this store event
   */
  clear(key: string): Events {
    if (Object(window.__GP_EVENTS__)[key]) {
      delete Object(window.__GP_EVENTS__)[key];
    }
    return this;
  }

  /**
   * on: watch events only one time
   * @param key key
   * @param _func func
   * @returns this store event
   */
  listenOnlyOne(key: string, _func: any): Events {
    Object(window.__GP_EVENTS__)[key] = {
      func: [_func],
    };
    return this;
  }
}

export default new Events();
